import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { StepButtonBar } from '../EditLegalListWizard/StepButtonBar';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { StepProps } from './types';
import UpdateConnectionInfo from './UpdateConnectionInfo';

const PRIMARY = '#c4122f';
const GREEN = '#4caf50';

interface Step4PreviewProps extends StepProps {
  selectedRowsData: any[];
  selectedCompanyUnit: any;
  onConfirmUpdate: () => Promise<void>;
  connectionAddedToLaws: Array<{ id: number; name: string; number: string }>;
  connectionRemovedFromLaws: Array<{ id: number; name: string; number: string }>;
  typeKey?: string;
  connectionName?: string;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
  
}

const Step4Preview = ({
  onNext,
  onBack,
  onCancel,
  onConfirmUpdate,
  connectionAddedToLaws,
  connectionRemovedFromLaws,
  selectedCompanyUnit,
  typeKey,
  connectionName,
  currentStepName,
  updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step4PreviewProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleConfirmUpdate = async () => {
    setIsUpdating(true);
    try {
      await onConfirmUpdate();
    } catch (error) {
      console.error('Update failed:', error);
      setIsUpdating(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '100%', padding: paperPadding, backgroundColor: '#f7f0f1', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: theme.spacing(2), lineHeight: 1.4, fontSize: isMobile ? '16px' : '18px' }}>
          <FormattedMessage
            id="law-portal.manage.update-laws.update.dialog.title"
            values={{
              type: typeKey
                ? formatMessage({
                    id: `law-portal.manage.update-laws.type.options.${typeKey}`,
                  }).toLowerCase()
                : undefined,
              connection: connectionName,
              em: (connectionName: any) => <em>{connectionName}</em>,
            }}
          />
        </Typography>

        {connectionAddedToLaws.length > 0 && (
          <Box style={{ display: 'flex', flexDirection: 'column', marginBottom: theme.spacing(2) }}>
            <Typography>
              <FormattedMessage id="law-portal.manage.update-laws.update.dialog.added-laws.message" />
            </Typography>
            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              {connectionAddedToLaws.map((law) => (
                <Box key={law.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 14px' }}>
                  <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', backgroundColor: GREEN, borderRadius: '6px', flexShrink: 0 }}>
                    <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: '24px' }} />
                  </Box>
                  <Typography variant="body2" style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}>
                    {law.number} – {law.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {connectionRemovedFromLaws.length > 0 && (
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography>
              <FormattedMessage id="law-portal.manage.update-laws.update.dialog.removed-laws.message" />
            </Typography>
            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              {connectionRemovedFromLaws.map((law) => (
                <Box key={law.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 14px' }}>
                  <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', backgroundColor: PRIMARY, borderRadius: '6px', flexShrink: 0 }}>
                    <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: '24px' }} />
                  </Box>
                  <Typography variant="body2" style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}>
                    {law.number} – {law.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </div>
      {/* <UpdateConnectionInfo
      updateConnectionInfo={updateConnectionInfo}
      currentStepName={currentStepName}
      onUpdate={setUpdateConnectionInfo}
    /> */}
      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleConfirmUpdate}
          nextLabel="law-portal.manage.update-laws.update.button"
          nextDisabled={isUpdating}
          isLoading={isUpdating}
          formatMessage={formatMessage}
          showBack={true}
          isDeleteStep={true}
        />
      </Box>
    </div>
  );
};

export default Step4Preview;
